import {
  GET_ASSESMENT_QUESTIONS,
  GET_ASSESMENT_QUESTIONS_SUCCESS,
  GET_ASSESMENT_QUESTIONS_FAILED,
  POST_ASSESMENT_QUESTIONS,
  POST_ASSESMENT_QUESTIONS_SUCCESS,
  POST_ASSESMENT_QUESTIONS_FAILED,
  GET_ASSESMENT_SHEET_LIST,
  GET_ASSESMENT_SHEET_LIST_SUCCESS,
  GET_ASSESMENT_SHEET_LIST_FAILED,
  CHANGE_THE_STATUS,
  CHANGE_THE_STATUS_SUCCESS,
  CHANGE_THE_STATUS_FAILED,
  GET_THE_SHEET_DATA,
  GET_THE_SHEET_DATA_SUCCESS,
  UPDATE_THE_SHEET,
  UPDATE_THE_SHEET_SUCCESS,
  UPDATE_THE_SHEET_FAILED,
  GET_SUGGESTION_FAILED,
  GET_SUGGESTION_SUCCESS,
  GET_SUGGESTION,
} from "./actionTypes";

export const getAssesmentQuestions = (id) => {
  return {
    type: GET_ASSESMENT_QUESTIONS,
    payload: id,
  };
};
export const getAssesmentQuestionsSuccess = (questions) => {
  return {
    type: GET_ASSESMENT_QUESTIONS_SUCCESS,
    payload: questions,
  };
};
export const getAssesmentQuestionsFailed = (error) => {
  return {
    type: GET_ASSESMENT_QUESTIONS_FAILED,
    payload: error,
  };
};

export const postAssesmentQuestions = (obj) => {
  return {
    type: POST_ASSESMENT_QUESTIONS,
    payload: obj,
  };
};

export const postAssesmentQuestionsSuccess = (res) => {
  return {
    type: POST_ASSESMENT_QUESTIONS_SUCCESS,
    payload: res,
  };
};

export const postAssesmentQuestionsFailed = (error) => {
  return {
    type: POST_ASSESMENT_QUESTIONS_FAILED,
    payload: error,
  };
};

export const getAssesmentSheets = (data) => {
  return {
    type: GET_ASSESMENT_SHEET_LIST,
    payload: data,
  };
};
export const getAssesmentSheetsSuccess = (sheets) => {
  return {
    type: GET_ASSESMENT_SHEET_LIST_SUCCESS,
    payload: sheets,
  };
};
export const getAssesmentSheetsFailed = (error) => {
  return {
    type: GET_ASSESMENT_SHEET_LIST_FAILED,
    payload: error,
  };
};

export const changeTheStatus = (data) => {
  return {
    type: CHANGE_THE_STATUS,
    payload: data,
  };
};

export const changeTheStatusSuccess = (message) => {
  return {
    type: CHANGE_THE_STATUS_SUCCESS,
    payload: message,
  };
};

export const changeTheStatusFailed = (error) => {
  return {
    type: CHANGE_THE_STATUS_FAILED,
    payload: error,
  };
};

export const getTheSheetData = (id) => {
  return {
    type: GET_THE_SHEET_DATA,
    payload: id,
  };
};

export const getTheSheetDataSuccess = (data) => {
  return {
    type: GET_THE_SHEET_DATA_SUCCESS,
    payload: data,
  };
};

export const getTheSheetDataFailed = (error) => {
  return {
    type: GET_THE_SHEET_DATA_SUCCESS,
    payload: error,
  };
};

export const updateTheSheet = (data) => {
  return {
    type: UPDATE_THE_SHEET,
    payload: data,
  };
};

export const updateTheSheetSuccess = (message) => {
  return {
    type: UPDATE_THE_SHEET_SUCCESS,
    payload: message,
  };
};

export const uptadeTheSheetFailed = (error) => {
  return {
    type: UPDATE_THE_SHEET_FAILED,
    payload: error,
  };
};


export const getAssessmentSuggestion = (data) => {
  return {
    type: GET_SUGGESTION,
    payload: data,
  };
};

export const getAssessmentSuggestionSuccess = (message) => {
  return {
    type: GET_SUGGESTION_SUCCESS,
    payload: message,
  };
};

export const getAssessmentSuggestionFailed  = (error) => {
  return {
    type: GET_SUGGESTION_FAILED,
    payload: error,
  };
};

